import React from 'react';
import cn from 'clsx';
import { formatToRub } from 'utils';
import { PriceMediaCardContent } from '../../../price-media-card';
import { Typography } from '../../../typography';
import {
  cartContent,
  cardContentCredit,
  cartContentPriceWrapper,
  cartContentTitle,
  cartContentValue,
} from './card-content-styles';

type CardContentProps = {
  className?: string;
  displayedName?: string;
  price?: number;
  withCredit?: boolean;
};

export const CardContent: React.FC<CardContentProps> = ({ className, displayedName, price, withCredit = true }) => (
  <PriceMediaCardContent className={cn(className, cartContent)}>
    {displayedName && (
      <Typography
        className={cartContentTitle}
        variant="m"
        size="body_accent">
        {displayedName}
      </Typography>
    )}
    {price && (
      <>
        <div className={cartContentPriceWrapper}>
          <Typography variant="m" size="body_accent" as="span">
            от
          </Typography>
          <Typography className={cartContentValue} variant="h2" as="span">
            {formatToRub(price)}
          </Typography>
          <Typography variant="m" size="body_accent" as="span">
            ₽
          </Typography>
        </div>
        {withCredit && (
          <Typography className={cardContentCredit} variant="caption_accent">
            от {formatToRub(Math.floor(price / 10))} ₽/мес
          </Typography>
        )}
      </>
    )}
  </PriceMediaCardContent>
);
